import axios from 'axios'
import { API } from './url'

function errMsg(e, fallback) {
  return (e.response && e.response.data && e.response.data.message) || fallback
}

// The tech team is sourced from HRM employees (active staff of the tech office),
// so this service is read-only — members are managed in HRM, not here.
export default {
  listAll: function(success, error) {
    axios.get(API.teamMembers.list)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load team members')) })
  },

  listActive: function(success, error) {
    axios.get(API.teamMembers.list, { params: { activeOnly: true } })
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load team members')) })
  }
}
